module.exports = __webpack_public_path__ + "static/media/alifian-aji-santoso.961a2c83.jpg";